import { Flex } from '@fastnorth/kraken/components/layout';
import { useTranslation } from 'react-i18next';
import { Search } from 'lucide-react';
import { Link } from 'react-router-dom';
import { NavLink } from '@fastnorth/kraken/components/navigation';

const EventSearchLink = (): React.JSX.Element => {
  const { t } = useTranslation('translation', { keyPrefix: 'karwa' });

  return (
    <Flex className={'w-full'}>
      <NavLink id={'event-search-link'} accent={'default'} variant={'menuPill'} width={'full'}>
        <Link to={'/search'} data-dd-action-name={'link-event_search-hamburger_menu'}>
          {t('components.navigation.event_search_label')}
          <Search role={'presentation'} size={16} strokeWidth={2} className={'ml-4'} />
        </Link>
      </NavLink>
    </Flex>
  );
};

export default EventSearchLink;
